import Iconify from '@iconify/iconify';
import 'lazysizes';
import Swiper, {Autoplay, Navigation} from 'swiper';
import Glightbox from 'glightbox';

window.GLightbox = Glightbox;
window.Swiper = Swiper;
Swiper.use([Autoplay, Navigation]);

if (document.querySelector('.nav__toggle')) {
    document.querySelectorAll('.nav__toggle, .nav__close').forEach(item => {
        item.addEventListener('click', (e) => {
            e.preventDefault();

            document.body.classList.toggle('nav--open');
        });
    });
}
